import React from 'react';
import { Container, Header, KeyValuePairs, SpaceBetween } from '@amzn/awsui-components-react-v3';

export interface ReviewAndSubmitProps {
  name: string;
  setName: any;
  description: string;
  setDescription: any;
  outputFormats: string[];
  setOutputFormats: any;
  accessProvider: string;
  setAccessProvider: any;
  governanceTag: string;
  setGovernanceTag: any;
  resourceArn: string;
  setResourceArn: any;
  status: string;
  setStatus: any;
  startDate: string;
  setStartDate: any;
  endDate: string;
  setEndDate: any;
}

export const ReviewAndSubmit = (props: ReviewAndSubmitProps) => {
  const outputFormatListToString = () => {
    return props.outputFormats.join(', ');
  };
  const notBlank = (str: string) => {
    return str && str.length > 0;
  };
  return (
    <SpaceBetween size={'l'} direction={'vertical'}>
      <Container header={<Header variant='h2'>Report details</Header>}>
        <KeyValuePairs
          columns={2}
          items={[
            { label: 'Name', value: props.name },
            { label: 'Description', value: props.description },
            { label: 'Output formats', value: outputFormatListToString() },
          ]}
        />
      </Container>
      <Container header={<Header variant='h2'>Access grant filters</Header>}>
        <KeyValuePairs
          columns={3}
          items={[
            notBlank(props.accessProvider) && { label: 'Access provider', value: props.accessProvider },
            notBlank(props.governanceTag) && { label: 'Governance tag', value: props.governanceTag },
            notBlank(props.resourceArn) && { label: 'Resource ARN', value: props.resourceArn },
            notBlank(props.status) && { label: 'Status', value: props.status },
            notBlank(props.startDate) && { label: 'Start date', value: props.startDate },
            notBlank(props.endDate) && { label: 'End date', value: props.endDate },
          ].filter((item) => item != undefined)}
        />
      </Container>
    </SpaceBetween>
  );
};
